"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapDirection = exports.WrapperName = exports.WrapperType = void 0;
var WrapperType;
(function (WrapperType) {
    WrapperType["WRAPPED_NATIVE"] = "WrappedNative";
    WrapperType["OVERNIGHT"] = "Overnight";
    WrapperType["DEUS"] = "Deus";
    WrapperType["WSTETH"] = "WstETH";
    WrapperType["WRAPPED_MAI"] = "WrappedMAI";
    WrapperType["WRAPPED_USDY"] = "WrappedUSDY";
})(WrapperType || (exports.WrapperType = WrapperType = {}));
var WrapperName;
(function (WrapperName) {
    WrapperName["WRAPPED_NATIVE"] = "Native Wrapper";
    WrapperName["OVERNIGHT"] = "Overnight Finance";
    WrapperName["DEUS"] = "DEUS Finance";
    WrapperName["WSTETH"] = "Lido Wrapped stETH";
    WrapperName["WRAPPED_MAI"] = "QiDAO Wrapped MAI";
    WrapperName["WRAPPED_USDY"] = "Ondo Finance";
})(WrapperName || (exports.WrapperName = WrapperName = {}));
var WrapDirection;
(function (WrapDirection) {
    WrapDirection["WRAP"] = "wrap";
    WrapDirection["UNWRAP"] = "unwrap";
})(WrapDirection || (exports.WrapDirection = WrapDirection = {}));
//# sourceMappingURL=index.js.map